import { MultiContainerHeader } from '../../components/MultiContainerHeader';
import { NotFound } from '../../components/NotFound';
import { baseStyleSheet } from '../../styles/styles';
import { styleSheet } from './styles';
import { css } from 'aphrodite';
import * as React from 'react';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../components-v2/Drawer/AppDrawer';
import { DefaultUniversalAssistantChat } from '../templates/AssistantChat';

export const NotFoundContainer = () => {
	return (
		<div className={css(styleSheet.container)}>
			<MultiContainerHeader
				appBarHeader={<div className={css(baseStyleSheet.cardWelcome)}>404</div>}
				fullscreenHeader=''
			/>
			<NotFound styles={[styleSheet.notFound]} />
			<AppDrawer>
				<StickyAppDrawerContent value='ai-assistant'>
					<DefaultUniversalAssistantChat />
				</StickyAppDrawerContent>
				<AppDrawerToolbar>
					<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
				</AppDrawerToolbar>
			</AppDrawer>
		</div>
	);
};
